module.exports = __webpack_public_path__ + "img/cc.8d316233.svg";